<template lang="pug">

TabsCard(variant="lg")
  template(#tabs)
    router-link.tab(:to="{name: 'cco-patient-navigation.patient-navigation.all_outstanding'}")
      .tab__inner
        .tab__first-child {{ summary.all_outstanding }}
        .tab__second-child All Referrals
    router-link.tab(:to="{name: 'cco-patient-navigation.patient-navigation.follow_up_due'}")
      .tab__inner
        .tab__first-child {{ summary.follow_up_due }}
        .tab__second-child Follow Up Due
    router-link.tab(:to="{name: 'cco-patient-navigation.patient-navigation.archived'}")
      .tab__inner
        .tab__first-child {{ summary.archived }}
        .tab__second-child Completed
  template(#content)
    router-view(
      @refreshAppointmentsSummary="refreshAppointmentsSummary"
    )

</template>

<script>
import { defineComponent } from "vue";
import TabsCard from "@/components/TabsCard.vue";
import { fetchPatientNavigation } from "@/api/patientNavigation";

export default defineComponent({
  components: {
    TabsCard,
  },
  emits: ["patientNavigationStats"],
  methods: {
    refreshAppointmentsSummary() {
      this.fetchSummaryInfo();
    },
    fetchSummaryInfo() {
      this.fetchPatientNavigation("ALL_OUTSTANDING");
      this.fetchPatientNavigation("FOLLOW_UP_DUE");
      this.fetchPatientNavigation("ARCHIVES");
    },
    async fetchPatientNavigation(stageParam) {
      try {
        let includeParams = ["patient", "cancelled"];
        let stageParamVal = stageParam;

        const res = await fetchPatientNavigation({
          params: {
            ...this.reqPagination,
            idCommunity: this.$route.params.idCommunity,
            include: includeParams,
            stage: stageParamVal,
          },
        });

        switch (stageParam) {
          case "ALL_OUTSTANDING":
            this.summary.all_outstanding = res.data.pagination.quantity;
            break;
          case "FOLLOW_UP_DUE":
            this.summary.follow_up_due = res.data.pagination.quantity;
            break;
          case "ARCHIVES":
            this.summary.archived = res.data.pagination.quantity;
            break;
        }

        this.pagination = res.data.pagination;
        this.$emit("patientNavigationStats", res.data.patientNavigationStats);
      } catch (err) {
        console.error(err);
      }
    },
  },
  data() {
    return {
      summary: {
        all_outstanding: 0,
        follow_up_due: 0,
        archived: 0,
      },
    };
  },
  created() {
    if (this.$route.params.idCommunity == null) return;
    this.fetchSummaryInfo();
  },
});
</script>
